import { render, staticRenderFns } from "./Enigma2.vue?vue&type=template&id=4fa685c1&scoped=true&"
import script from "./Enigma2.vue?vue&type=script&lang=js&"
export * from "./Enigma2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa685c1",
  null
  
)

export default component.exports